import { render, staticRenderFns } from "./SalesFarmerPopup.vue?vue&type=template&id=bffebc78&scoped=true"
import script from "./SalesFarmerPopup.vue?vue&type=script&lang=js"
export * from "./SalesFarmerPopup.vue?vue&type=script&lang=js"
import style0 from "./SalesFarmerPopup.vue?vue&type=style&index=0&id=bffebc78&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffebc78",
  null
  
)

export default component.exports